import React, { useRef, useState, useEffect } from 'react'
import axios from 'axios'
import '../../../v2SPRINTA/style.css'
import { Col, Row, Container } from '../../../SPRINTA/v3/Grid'
import Button from '../../../SPRINTA/v3/Button'
import style from './style.module.css'
import { InputText, Textarea, Radio, Label, Checkbox, Select, useForm } from '../../../SPRINTA/v3/Form'
import AspectRatio from '../../../SPRINTA/atoms/AspectRatio'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'
import ProgressBar from '../../../SPRINTA/atoms/ProgressBar'
import Loading from '../../../SPRINTA/atoms/Loading'
import Dialog from '../../../v2SPRINTA/molecules/Dialog'

function CreateProduct(props) {
    const dialogRef = useRef(null)
    const focusRef = useRef(null)
    const [images, setImages] = useState([
        null, null, null, null, null
    ])
    const [imagesPreview, setImagesPreview] = useState([
        null, null, null, null, null
    ])
    const [done, setDone] = useState(false)
    const [imageError, setImageError] = useState(false)
    const [progress, setProgress] = useState(null)
    const [prodData, setProdData] = useState(null)

    const [model, formData] = useForm({
        title: "",
        condition: "new",
        nobrand: false,
        price: "",
        cep: "",
        store: "",
        weight: "",
        width: "",
        height: "",
        length: "",
        department: "",
        category: "",
        subcategory: "",
        description: "",
        quantity: 1,
        brand: "",
        size: "",
    })

    const [data, setData] = useState({
        brands: null,
        departments: null,
        categories: [],
        subcategories: [],
        sizes: [],
        stores: null,
    })

    useEffect(() => {
        axios.get("product/brands")
        .then(brands => {
            setData(data => ({
                ...data,
                brands: brands.result
            }))
        })

        axios.get("product/departments")
        .then(departments => {
            setData(data => ({
                ...data,
                departments: departments.result
            }))
        })

        axios.get("product/stores")
        .then(stores => {
            if(stores.result.length > 0) {
                model.store.setValue(stores.result[0].id)
            }
            setData(data => ({
                ...data,
                stores: stores.result
            }))
        })
    }, [])

    useEffect(() => {
        model.category.setValue("")
        model.subcategory.setValue("")
        model.size.setValue("")

        if(!formData.department) {
            setData(data => ({...data, categories: [], subcategories: [], sizes: []}))
            return
        } 
        

        setData(data => ({...data, categories: null, subcategories: [], sizes: []}))
        axios.get("product/categories/" + formData.department)
        .then(categories => {
            setData(data => ({
                ...data,
                categories: categories.result
            }))
        })
    }, [formData.department])

    useEffect(() => {

        model.subcategory.setValue("")
        model.size.setValue("")
        
        if(!formData.category) return setData(data => ({...data, subcategories: [], sizes: []}))

        setData(data => ({...data, subcategories: null, sizes: []}))
        axios.get("product/subcategories/" + formData.category)
        .then(subcategories => {
            setData(data => ({
                ...data,
                subcategories: subcategories.result
            }))
        })
    }, [formData.category])

    useEffect(() => {
        model.size.setValue("")
        if(!formData.subcategory) return setData(data => ({...data, sizes: []}))

        setData(data => ({...data, sizes: null}))
        axios.get("product/sizes/" + formData.subcategory)
        .then(sizes => {
            setData(data => ({
                ...data,
                sizes: sizes.result
            }))
        })
    }, [formData.subcategory])

    function uploadFile(inx, file) {
        let ims = [...images]
        let imsp = [...imagesPreview]
        if(file === null) {
            ims[inx] = null
            imsp[inx] = null
        } else {   
            ims[inx] = file
            imsp[inx] = URL.createObjectURL(file)
        }
        
        setImagesPreview([...imsp])
        setImages([...ims])
    }

    function submit(e) {
        e.preventDefault()

        let error = false
        if(!formData.title) {   
            error = true
            model.title.ref.current.error()
        }
        if(!formData.price) {   
            error = true
            model.price.ref.current.error()
        }
        if(!formData.description) {   
            error = true
            model.description.ref.current.error()
        }
        if(!formData.condition) {   
            error = true
            model.condition.ref.current.error()
        }

        if(!formData.nobrand && !formData.brand) {   
            error = true
            model.brand.ref.current.error()
        }

        if(!formData.department) {   
            error = true
            model.department.ref.current.error()
        }

        if(!formData.width) {   
            error = true
            model.width.ref.current.error()
        }

        if(!formData.height) {   
            error = true
            model.height.ref.current.error()
        }

        if(!formData.length) {   
            error = true
            model.length.ref.current.error()
        }
        
        if(!formData.weight) {   
            error = true
            model.weight.ref.current.error()
        }

        if(!formData.department) {   
            error = true
            model.department.ref.current.error()
        }
        
        if(data.categories.length > 0 && !formData.category) {   
            error = true
            model.category.ref.current.error()
        }

        if(data.subcategories.length > 0 && !formData.subcategory) {   
            error = true
            model.subcategory.ref.current.error()
        }

        if(data.sizes.length > 0 && !formData.size) {   
            error = true
            model.size.ref.current.error()
        }

        if(!formData.cep) {   
            error = true
            model.cep.ref.current.error()
        }

        if(!images[0]) {
            error = true
            setImageError(true)
        }

        let toScroll = focusRef.current.getBoundingClientRect().top + window.scrollY - 120
        if(error) {
            if(window.scrollY > toScroll)
            window.scrollTo(window.scrollX, toScroll)
            return
        }

        //upload
        setProgress(0)
        const fd = new FormData()
        Object.keys(formData).map(name => {
            let value = formData[name]
            if(name === 'weight') {
                value = parseFloat(value.replace(",", "."))
            }
            if(name === 'price') {
                value = value.replace(/\D/g,"")/100
            }
            fd.append(name, value)
        })

        let upImages = []
        let progressed = []
        images.map((img) => {
            if(img) {
                upImages.push(img)
                progressed.push(0)
            }
        })

        fd.append("image", upImages[0])
        axios.post("product/create", fd,  {
            onUploadProgress: progressEvent => {
                let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                progressed[0] = percentCompleted
                setProgress(progressed.reduce((p, c) => p += c) / progressed.length)
            }
       })
        .then(resp => {
            if(resp.errors && resp.errors[0]) {
                setProgress(null)
                dialogRef.current.alert(resp.errors[0].message)
                return
            }

            setProdData({
                id: resp.id,
                title: formData.title,
                storeToken: resp.marketplace.token,
                image: imagesPreview[0]
            })

            let toUpImages = upImages.slice(1, upImages.length)
            if(toUpImages.length === 0) {
                setProgress(null)
                window.scrollTo(window.scrollX, 0)
                setDone(true)
                return
            }

            let promises = []
            toUpImages.map((upi, k) => {
                const fdi = new FormData()
                fdi.append("image", upi)
                promises.push(axios.post("product/image/"+resp.id, fdi,  {
                    onUploadProgress: progressEvent => {
                        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
                        progressed[k+1] = percentCompleted
                        setProgress(progressed.reduce((p, c) => p += c) / progressed.length)
                    }
               }))
            })

            Promise.all(promises).then(() => {
                setProgress(null)
                window.scrollTo(window.scrollX, 0)
                setDone(true)
                return
            })
        })

    }

    console.log(prodData)

    if(done) return <Done data={prodData} />

    return (
        <form onSubmit={submit}>
            <Dialog ref={dialogRef} />
            <Container>
                <Row justifyContent='center' mb="20">
                    <Col size='12 9'>
                        <Row mt="11" mb="7">
                            <Col text='center'>
                                <span className={style.title}>Você está prestes a anunciar seu produto para 1 milhão de atletas</span>
                            </Col>
                        </Row>
                        <Row mb='8'>
                            <Col text='center'>
                                <div className={style.boxMessage}>
                                    <strong>Você é organizador ou lojista?</strong>
                                    <br/>
                                    Tenha sua loja oficial dentro da nossa plataforma
                                </div>
                            </Col>
                        </Row>
                        <Row mb='1' gutter='2' ref={focusRef}>
                            <Col size='12 4' order='1 0'>
                                <Row>
                                    <Col size='12'>
                                        <Label>Fotos (capriche)</Label>
                                    </Col>
                                </Row>
                                <Row mb="1" gutter=".5">
                                    <Col size='12'>
                                        <RenderImage
                                            error={imageError}
                                            image={imagesPreview[0] ? imagesPreview[0] : null}
                                            setFile={file => {
                                                uploadFile(0, file)
                                                setImageError(false)
                                            }}
                                        />
                                    </Col>
                                </Row>
                                <Row mb="1" gutter=".5">
                                    <Col size='6'>
                                        <RenderImage
                                            image={imagesPreview[1] ? imagesPreview[1] : null}
                                            setFile={file => uploadFile(1, file)}
                                        />
                                    </Col>
                                    <Col size='6'>
                                        <RenderImage
                                            image={imagesPreview[2] ? imagesPreview[2] : null}
                                            setFile={file => uploadFile(2, file)}
                                        />
                                    </Col>
                            </Row>
                                <Row mb="1" gutter=".5">
                                    <Col size='6'>
                                        <RenderImage
                                            image={imagesPreview[3] ? imagesPreview[3] : null}
                                            setFile={file => uploadFile(3, file)}
                                        />
                                    </Col>
                                    <Col size='6'>
                                        <RenderImage
                                            image={imagesPreview[4] ? imagesPreview[4] : null}
                                            setFile={file => uploadFile(4, file)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col size='12 8' order='0 1' mb="2">
                                <Row>
                                    <Col size='12' mb="2">
                                        <InputText
                                            required
                                            label='Título do produto'
                                            model={model.title}
                                        />
                                    </Col>
                                    <Col size='6 4' mb='2'>
                                        <InputText
                                            rtl
                                            leftIcon={() => <span>R$</span>}
                                            label='Preço'
                                            mask="brl"
                                            required
                                            model={model.price}
                                        />
                                    </Col>
                                    <Col size='12' mb='2' order='1 0'>
                                        <Textarea
                                            label='Descrição'
                                            maxLength={500}
                                            style={{ height: '164px' }}
                                            model={model.description}
                                            required
                                        />
                                    </Col>
                                    <Col size='5 4' mb='3' order='1 0'>
                                        <Radio
                                            label="Produto novo"
                                            model={model.condition}
                                            value="new"
                                        />
                                    </Col>
                                    <Col size='5 4' mb='3' order='1 0'>
                                        <Radio
                                            label="Produto usado"
                                            model={model.condition}
                                            value="used"
                                        />
                                    </Col>

                                    <Col size='12' mb='3' order='1 0'>
                                        <div className={style.divider} />
                                    </Col>

                                    <Col size='6 4' mb='2 4' order='0'>
                                        <Select
                                            label='Departamento'
                                            required
                                            model={model.department}
                                        >
                                            <option value=''>{data.departments === null ? `Carregando...` : `Selecione` }</option>
                                            {data.departments && data.departments.map(i => <option value={i.id} key={i.id}>{i.name}</option>)}
                                        </Select>
                                    </Col>
                                    <Col size='6 4' mb='4' order='3 0'>
                                        <Select
                                            label='Categoria'
                                            required
                                            model={model.category}
                                            disabled={data.categories && data.categories.length === 0}
                                        >
                                            <option value=''>{data.categories === null ? `Carregando...` : data.categories.length ? `Selecione` : '' }</option>
                                            {data.categories && data.categories.map(i => <option value={i.id} key={i.id}>{i.name}</option>)}
                                        </Select>
                                    </Col>
                                    <Col size='6 4' mb='4' order='3 0'>
                                        <Select
                                            label='Subcategoria'
                                            required
                                            disabled
                                            model={model.subcategory}
                                            disabled={data.subcategories && data.subcategories.length === 0}
                                        >
                                            <option value=''>{data.subcategories === null ? `Carregando...` : data.subcategories.length ? `Selecione` : '' }</option>
                                            {data.subcategories && data.subcategories.map(i => <option value={i.id} key={i.id}>{i.name}</option>)}
                                        </Select>
                                    </Col>
                                    <Col size='12' mb='4' order='3 0'>
                                        <div className={style.divider} />
                                    </Col>
                                
                                    <Col size='12 4' mb='4' order='2 0'>
                                        <Row justifyContent='flex-end flex-start'>
                                            <Col size='12' mb='2'>
                                                <Select
                                                    label='Marca'
                                                    required
                                                    model={model.brand}
                                                    disabled={model.nobrand.value}
                                                >
                                                    <option value=''>{data.brands === null ? `Carregando...` : `Selecione` }</option>

                                                    {data.brands && data.brands.map(i => <option value={i.id} key={i.id}>{i.name}</option>)}
                                                </Select>
                                            </Col>
                                            <Col size='auto 12'>
                                                <Checkbox
                                                    label="Produto sem marca"
                                                    model={model.nobrand}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col size='6 4' mb='4' order='3 0'>
                                        <Select
                                            label='Tamanho'
                                            required
                                            model={model.size}
                                            disabled={data.sizes && data.sizes.length === 0}
                                        >
                                            <option value=''>{data.sizes === null ? `Carregando...` : data.sizes.length ? `Selecione` : '' }</option>
                                            {data.sizes && data.sizes.map(i => <option value={i.id} key={i.id}>{i.name}</option>)}
                                        </Select>
                                    </Col>
                                    <Col size='6 4' mb='4' order='3 0'>
                                        <InputText
                                            label='Quantidade'
                                            required
                                            format={v => {
                                                v = parseInt(v, 10)
                                                if(v > 10) return 10
                                                if(v < 1) return 1

                                                return v
                                            }}
                                            model={model.quantity}
                                        />
                                    </Col>
                                    <Col size='12' mb='4' order='3 0'>
                                        <div className={style.divider} />
                                    </Col>
                                
                                    <Col size='6' mb='4' order='3 0'>
                                        <InputText
                                            label='Peso do produto'
                                            required
                                            model={model.weight}
                                            format={v => {
                                                v = v.replace(/[^0-9,]+/g,"")
                                                if((v.split(",").length - 1) > 1) {
                                                    v = v.slice(0, v.length -1 )
                                                }
                                                return v
                                            }}
                                            rightIcon={() => <span>kg</span>}
                                        />
                                    </Col>
                                    <Col size='6' mb='4' order='3 0'>
                                        <InputText
                                            label='Tipo de entrega'
                                            readOnly
                                            value="Correios ou transportadora"
                                        />
                                    </Col>
                                
                                    <Col size='6 4' mb='2' order='3 0'>
                                        <InputText
                                            label='Largura do produto'
                                            required
                                            mask='number'
                                            model={model.width}
                                        />
                                    </Col>
                                    <Col size='6 4' mb='2' order='3 0'>
                                        <InputText
                                            label='Comprimento'
                                            required
                                            mask='number'
                                            model={model.length}
                                        />
                                    </Col>
                                    <Col size='6 4' mb='2' order='3 0'>
                                        <InputText
                                            label='Altura'
                                            required
                                            mask='number'
                                            model={model.height}
                                        />
                                    </Col>
                                    <Col size='12' mb='4' order='3 0'>
                                        <div className={style.messageInfo}>
                                            Se você tem dúvidas sobre como verificar as medidas, <a href='https://app.sprinta.com.br/user/sprinta?post_target=29260637cbc581eb' target='_blanck'>clique aqui para ver nosso artigo</a>.
                                        </div>
                                    </Col>
                                    <Col size='12' mb='2' order='3 0'>
                                        <div className={style.divider} />
                                    </Col>
                                    <Col size='6' mb='2' order='3 0'>
                                        <InputText
                                            label='CEP onde o produto se encontra'
                                            required
                                            mask="#####-###"
                                            model={model.cep}
                                        />
                                    </Col>
                                    {(data.stores === null || data.stores.length > 0) && (
                                        <Col size='6' mb='2' order='3 0'>
                                            <Select
                                                label='Loja'
                                                required
                                                model={model.store}
                                            >
                                                {data.stores === null && <option value=''>Carregando...</option>}
                                                {data.stores && data.stores.map(i => <option value={i.id} key={i.id}>{i.title}</option>)}
                                            </Select>
                                        </Col>
                                    )}

                                    <Col size='12 hidden' mb='2' mt='2' order='3 0'>
                                        <div className={style.divider} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        

                        {progress !== null && (
                            <Row alignItems='center' mb='4'>
                                <Col size='hidden 4'></Col>
                                <Col>
                                    <ProgressBar theme='orange' progress={progress} />
                                </Col>
                            </Row>
                        )}
                        
                        <Row justifyContent='flex-end'>
                            <Col size='auto' text='right'>
                                {progress !== null ? (
                                    <Loading />
                                ) : (
                                    <Button primary inline>Cadastrar produto</Button>
                                )}
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Container>
        </form>
    
    )
}

function RenderImage(props) {
    const fileRef = useRef(null)
    const image = props.image

    function changeFile({ target }) {
        let file = target.files[0]
        props.setFile(file)
        target.value = ''
    }

    return (
        <AspectRatio image={image} center color='#E8E8E8' style={{
            border: !props.error ? `1px solid #E8E8E8` : "1px solid #ff0000",
        }}>
            <input
                type='file'
                className={style.file}
                ref={fileRef}
                accept="image/*"
                onChange={changeFile} />

            <div className={style.setImage} onClick={() => {
                if(image) {
                    props.setFile(null)
                } else {
                    fileRef.current.click()
                }
            }}>
                {image ? (
                    <div className={style.trash}>
                        <div className={style.rounded}>
                            <FontIcon name='trash' size={35} color='#fff'/>
                        </div>
                    </div>
                ) : (
                    <FontIcon name='camera' size={35} color='#ccc'/>
                )}
            </div>
        </AspectRatio>
    )
}

function Done({ data }) {
    return (
        <Container>
            <Row justifyContent='center' mb="20">
                <Col size='12 9'>
                    <Row mt="11" mb="3" justifyContent='center'>
                        <Col text='center' size="8">
                            <span className={style.title}>Prontinho! <br /> Seu produto já está disponível e logo irá para nosso marketplace.</span>
                        </Col>
                    </Row>
                    <Row mb="3">
                        <Col text='center'>
                            <div className={style.boxMessage}>
                                <strong>Fique atento!</strong>
                                <br/>
                                Um de nossos gerentes pode entrar em contato para validar alguns dados
                            </div>
                        </Col>
                    </Row>
                    <Row mb='3' justifyContent='center'>
                        <Col size='auto'>
                            <div style={{ width: '238px' }}>
                                <AspectRatio image={data.image} rounded center style={{
                                    border: `1px solid #E8E8E8`,
                                    borderRadius: '100%'
                                }} />
                            </div>
                        </Col>
                    </Row>
                    <Row mb="3">
                        <Col size='12' text='center'>
                            <div className={style.title}>
                                {data.title}
                            </div>
                        </Col>
                    </Row>
                    <Row mb="3" justifyContent='center'>
                        <Col size='auto'>
                            <a href={`/marketplace/${data.storeToken}/${data.id}`}>
                                <Button primary>Ver anúncio</Button>
                            </a>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )

}

export default CreateProduct


// WEBPACK FOOTER //
// ./src/App/pages/CreateProduct/index.js